/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthLayoutRouteImport } from './routes/_authLayout'
import { Route as BaseLayoutRouteImport } from './routes/_baseLayout'
import { Route as FullWidthLayoutRouteImport } from './routes/_fullWidthLayout'
import { Route as BaseLayoutIndexRouteImport } from './routes/_baseLayout/index'
import { Route as BaseLayoutModelsRouteImport } from './routes/_baseLayout/models'
import { Route as AuthLayoutForgottenPasswordIndexRouteImport } from './routes/_authLayout/forgotten-password/index'
import { Route as AuthLayoutLoginIndexRouteImport } from './routes/_authLayout/login/index'
import { Route as AuthLayoutRegisterIndexRouteImport } from './routes/_authLayout/register/index'
import { Route as AuthLayoutResetPasswordIndexRouteImport } from './routes/_authLayout/reset-password/index'
import { Route as AuthLayoutVerifyIndexRouteImport } from './routes/_authLayout/verify/index'
import { Route as BaseLayoutAgentToolsIndexRouteImport } from './routes/_baseLayout/agent-tools/index'
import { Route as BaseLayoutChatsIndexRouteImport } from './routes/_baseLayout/chats/index'
import { Route as BaseLayoutChatsCreateRouteImport } from './routes/_baseLayout/chats/create'
import { Route as BaseLayoutKnowledgeBaseIndexRouteImport } from './routes/_baseLayout/knowledge-base/index'
import { Route as BaseLayoutOrganizationsIndexRouteImport } from './routes/_baseLayout/organizations/index'
import { Route as BaseLayoutOrganizationsCreateRouteImport } from './routes/_baseLayout/organizations/create'
import { Route as BaseLayoutPartnerBillingOrganizationIdRouteImport } from './routes/_baseLayout/partner-billing/$organizationId'
import { Route as BaseLayoutUsersIndexRouteImport } from './routes/_baseLayout/users/index'
import { Route as BaseLayoutUsersCreateRouteImport } from './routes/_baseLayout/users/create'
import { Route as FullWidthLayoutInboxIndexRouteImport } from './routes/_fullWidthLayout/inbox/index'
import { Route as AuthLayoutForgottenPasswordSentIndexRouteImport } from './routes/_authLayout/forgotten-password/sent/index'
import { Route as AuthLayoutRegisterSentIndexRouteImport } from './routes/_authLayout/register/sent/index'
import { Route as BaseLayoutAgentToolsClientSideNewRouteImport } from './routes/_baseLayout/agent-tools/client-side/new'
import { Route as BaseLayoutChatsChatIdEditRouteImport } from './routes/_baseLayout/chats/$chatId/edit'
import { Route as BaseLayoutOrganizationsOrganizationIdBillingRouteImport } from './routes/_baseLayout/organizations/$organizationId/billing'
import { Route as BaseLayoutOrganizationsOrganizationIdEditRouteImport } from './routes/_baseLayout/organizations/$organizationId/edit'
import { Route as BaseLayoutOrganizationsOrganizationIdPaymentsRouteImport } from './routes/_baseLayout/organizations/$organizationId/payments'
import { Route as BaseLayoutOrganizationsOrganizationIdSubscriptionsRouteImport } from './routes/_baseLayout/organizations/$organizationId/subscriptions'
import { Route as BaseLayoutUsersUserIdEditRouteImport } from './routes/_baseLayout/users/$userId/edit'
import { Route as BaseLayoutUsersProfileIndexRouteImport } from './routes/_baseLayout/users/profile/index'
import { Route as BaseLayoutAgentToolsClientSideFormToolIdEditRouteImport } from './routes/_baseLayout/agent-tools/client-side/$formToolId/edit'
import { Route as BaseLayoutChatsChatIdDocumentsIndexRouteImport } from './routes/_baseLayout/chats/$chatId/documents/index'
import { Route as BaseLayoutChatsChatIdFaqsIndexRouteImport } from './routes/_baseLayout/chats/$chatId/faqs/index'
import { Route as BaseLayoutChatsChatIdFaqsCreateRouteImport } from './routes/_baseLayout/chats/$chatId/faqs/create'
import { Route as BaseLayoutChatsChatIdFeedsIndexRouteImport } from './routes/_baseLayout/chats/$chatId/feeds/index'
import { Route as BaseLayoutOrganizationsOrganizationIdPlanManagementIndexRouteImport } from './routes/_baseLayout/organizations/$organizationId/plan-management/index'
import { Route as BaseLayoutChatsChatIdFaqsFaqIdEditRouteImport } from './routes/_baseLayout/chats/$chatId/faqs/$faqId/edit'
import { Route as BaseLayoutChatsChatIdFeedsFeedIdAttributesRouteImport } from './routes/_baseLayout/chats/$chatId/feeds/$feedId/attributes'
import { Route as BaseLayoutChatsChatIdFeedsFeedIdProductsRouteImport } from './routes/_baseLayout/chats/$chatId/feeds/$feedId/products'

const AuthLayoutRoute = AuthLayoutRouteImport.update({
  id: '/_authLayout',
  getParentRoute: () => rootRouteImport,
} as any)
const BaseLayoutRoute = BaseLayoutRouteImport.update({
  id: '/_baseLayout',
  getParentRoute: () => rootRouteImport,
} as any)
const FullWidthLayoutRoute = FullWidthLayoutRouteImport.update({
  id: '/_fullWidthLayout',
  getParentRoute: () => rootRouteImport,
} as any)
const BaseLayoutIndexRoute = BaseLayoutIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => BaseLayoutRoute,
} as any)
const BaseLayoutModelsRoute = BaseLayoutModelsRouteImport.update({
  id: '/models',
  path: '/models',
  getParentRoute: () => BaseLayoutRoute,
} as any)
const AuthLayoutForgottenPasswordIndexRoute =
  AuthLayoutForgottenPasswordIndexRouteImport.update({
    id: '/forgotten-password/',
    path: '/forgotten-password/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const AuthLayoutLoginIndexRoute = AuthLayoutLoginIndexRouteImport.update({
  id: '/login/',
  path: '/login/',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthLayoutRegisterIndexRoute = AuthLayoutRegisterIndexRouteImport.update({
  id: '/register/',
  path: '/register/',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const AuthLayoutResetPasswordIndexRoute =
  AuthLayoutResetPasswordIndexRouteImport.update({
    id: '/reset-password/',
    path: '/reset-password/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const AuthLayoutVerifyIndexRoute = AuthLayoutVerifyIndexRouteImport.update({
  id: '/verify/',
  path: '/verify/',
  getParentRoute: () => AuthLayoutRoute,
} as any)
const BaseLayoutAgentToolsIndexRoute =
  BaseLayoutAgentToolsIndexRouteImport.update({
    id: '/agent-tools/',
    path: '/agent-tools/',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsIndexRoute = BaseLayoutChatsIndexRouteImport.update({
  id: '/chats/',
  path: '/chats/',
  getParentRoute: () => BaseLayoutRoute,
} as any)
const BaseLayoutChatsCreateRoute = BaseLayoutChatsCreateRouteImport.update({
  id: '/chats/create',
  path: '/chats/create',
  getParentRoute: () => BaseLayoutRoute,
} as any)
const BaseLayoutKnowledgeBaseIndexRoute =
  BaseLayoutKnowledgeBaseIndexRouteImport.update({
    id: '/knowledge-base/',
    path: '/knowledge-base/',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutOrganizationsIndexRoute =
  BaseLayoutOrganizationsIndexRouteImport.update({
    id: '/organizations/',
    path: '/organizations/',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutOrganizationsCreateRoute =
  BaseLayoutOrganizationsCreateRouteImport.update({
    id: '/organizations/create',
    path: '/organizations/create',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutPartnerBillingOrganizationIdRoute =
  BaseLayoutPartnerBillingOrganizationIdRouteImport.update({
    id: '/partner-billing/$organizationId',
    path: '/partner-billing/$organizationId',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutUsersIndexRoute = BaseLayoutUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => BaseLayoutRoute,
} as any)
const BaseLayoutUsersCreateRoute = BaseLayoutUsersCreateRouteImport.update({
  id: '/users/create',
  path: '/users/create',
  getParentRoute: () => BaseLayoutRoute,
} as any)
const FullWidthLayoutInboxIndexRoute =
  FullWidthLayoutInboxIndexRouteImport.update({
    id: '/inbox/',
    path: '/inbox/',
    getParentRoute: () => FullWidthLayoutRoute,
  } as any)
const AuthLayoutForgottenPasswordSentIndexRoute =
  AuthLayoutForgottenPasswordSentIndexRouteImport.update({
    id: '/forgotten-password/sent/',
    path: '/forgotten-password/sent/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const AuthLayoutRegisterSentIndexRoute =
  AuthLayoutRegisterSentIndexRouteImport.update({
    id: '/register/sent/',
    path: '/register/sent/',
    getParentRoute: () => AuthLayoutRoute,
  } as any)
const BaseLayoutAgentToolsClientSideNewRoute =
  BaseLayoutAgentToolsClientSideNewRouteImport.update({
    id: '/agent-tools/client-side/new',
    path: '/agent-tools/client-side/new',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsChatIdEditRoute =
  BaseLayoutChatsChatIdEditRouteImport.update({
    id: '/chats/$chatId/edit',
    path: '/chats/$chatId/edit',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutOrganizationsOrganizationIdBillingRoute =
  BaseLayoutOrganizationsOrganizationIdBillingRouteImport.update({
    id: '/organizations/$organizationId/billing',
    path: '/organizations/$organizationId/billing',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutOrganizationsOrganizationIdEditRoute =
  BaseLayoutOrganizationsOrganizationIdEditRouteImport.update({
    id: '/organizations/$organizationId/edit',
    path: '/organizations/$organizationId/edit',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutOrganizationsOrganizationIdPaymentsRoute =
  BaseLayoutOrganizationsOrganizationIdPaymentsRouteImport.update({
    id: '/organizations/$organizationId/payments',
    path: '/organizations/$organizationId/payments',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute =
  BaseLayoutOrganizationsOrganizationIdSubscriptionsRouteImport.update({
    id: '/organizations/$organizationId/subscriptions',
    path: '/organizations/$organizationId/subscriptions',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutUsersUserIdEditRoute =
  BaseLayoutUsersUserIdEditRouteImport.update({
    id: '/users/$userId/edit',
    path: '/users/$userId/edit',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutUsersProfileIndexRoute =
  BaseLayoutUsersProfileIndexRouteImport.update({
    id: '/users/profile/',
    path: '/users/profile/',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutAgentToolsClientSideFormToolIdEditRoute =
  BaseLayoutAgentToolsClientSideFormToolIdEditRouteImport.update({
    id: '/agent-tools/client-side/$formToolId/edit',
    path: '/agent-tools/client-side/$formToolId/edit',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsChatIdDocumentsIndexRoute =
  BaseLayoutChatsChatIdDocumentsIndexRouteImport.update({
    id: '/chats/$chatId/documents/',
    path: '/chats/$chatId/documents/',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsChatIdFaqsIndexRoute =
  BaseLayoutChatsChatIdFaqsIndexRouteImport.update({
    id: '/chats/$chatId/faqs/',
    path: '/chats/$chatId/faqs/',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsChatIdFaqsCreateRoute =
  BaseLayoutChatsChatIdFaqsCreateRouteImport.update({
    id: '/chats/$chatId/faqs/create',
    path: '/chats/$chatId/faqs/create',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsChatIdFeedsIndexRoute =
  BaseLayoutChatsChatIdFeedsIndexRouteImport.update({
    id: '/chats/$chatId/feeds/',
    path: '/chats/$chatId/feeds/',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutOrganizationsOrganizationIdPlanManagementIndexRoute =
  BaseLayoutOrganizationsOrganizationIdPlanManagementIndexRouteImport.update({
    id: '/organizations/$organizationId/plan-management/',
    path: '/organizations/$organizationId/plan-management/',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsChatIdFaqsFaqIdEditRoute =
  BaseLayoutChatsChatIdFaqsFaqIdEditRouteImport.update({
    id: '/chats/$chatId/faqs/$faqId/edit',
    path: '/chats/$chatId/faqs/$faqId/edit',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsChatIdFeedsFeedIdAttributesRoute =
  BaseLayoutChatsChatIdFeedsFeedIdAttributesRouteImport.update({
    id: '/chats/$chatId/feeds/$feedId/attributes',
    path: '/chats/$chatId/feeds/$feedId/attributes',
    getParentRoute: () => BaseLayoutRoute,
  } as any)
const BaseLayoutChatsChatIdFeedsFeedIdProductsRoute =
  BaseLayoutChatsChatIdFeedsFeedIdProductsRouteImport.update({
    id: '/chats/$chatId/feeds/$feedId/products',
    path: '/chats/$chatId/feeds/$feedId/products',
    getParentRoute: () => BaseLayoutRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof BaseLayoutIndexRoute
  '/models': typeof BaseLayoutModelsRoute
  '/chats/create': typeof BaseLayoutChatsCreateRoute
  '/organizations/create': typeof BaseLayoutOrganizationsCreateRoute
  '/partner-billing/$organizationId': typeof BaseLayoutPartnerBillingOrganizationIdRoute
  '/users/create': typeof BaseLayoutUsersCreateRoute
  '/forgotten-password/': typeof AuthLayoutForgottenPasswordIndexRoute
  '/login/': typeof AuthLayoutLoginIndexRoute
  '/register/': typeof AuthLayoutRegisterIndexRoute
  '/reset-password/': typeof AuthLayoutResetPasswordIndexRoute
  '/verify/': typeof AuthLayoutVerifyIndexRoute
  '/agent-tools/': typeof BaseLayoutAgentToolsIndexRoute
  '/chats/': typeof BaseLayoutChatsIndexRoute
  '/knowledge-base/': typeof BaseLayoutKnowledgeBaseIndexRoute
  '/organizations/': typeof BaseLayoutOrganizationsIndexRoute
  '/users/': typeof BaseLayoutUsersIndexRoute
  '/inbox/': typeof FullWidthLayoutInboxIndexRoute
  '/agent-tools/client-side/new': typeof BaseLayoutAgentToolsClientSideNewRoute
  '/chats/$chatId/edit': typeof BaseLayoutChatsChatIdEditRoute
  '/organizations/$organizationId/billing': typeof BaseLayoutOrganizationsOrganizationIdBillingRoute
  '/organizations/$organizationId/edit': typeof BaseLayoutOrganizationsOrganizationIdEditRoute
  '/organizations/$organizationId/payments': typeof BaseLayoutOrganizationsOrganizationIdPaymentsRoute
  '/organizations/$organizationId/subscriptions': typeof BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute
  '/users/$userId/edit': typeof BaseLayoutUsersUserIdEditRoute
  '/forgotten-password/sent/': typeof AuthLayoutForgottenPasswordSentIndexRoute
  '/register/sent/': typeof AuthLayoutRegisterSentIndexRoute
  '/users/profile/': typeof BaseLayoutUsersProfileIndexRoute
  '/agent-tools/client-side/$formToolId/edit': typeof BaseLayoutAgentToolsClientSideFormToolIdEditRoute
  '/chats/$chatId/faqs/create': typeof BaseLayoutChatsChatIdFaqsCreateRoute
  '/chats/$chatId/documents/': typeof BaseLayoutChatsChatIdDocumentsIndexRoute
  '/chats/$chatId/faqs/': typeof BaseLayoutChatsChatIdFaqsIndexRoute
  '/chats/$chatId/feeds/': typeof BaseLayoutChatsChatIdFeedsIndexRoute
  '/organizations/$organizationId/plan-management/': typeof BaseLayoutOrganizationsOrganizationIdPlanManagementIndexRoute
  '/chats/$chatId/faqs/$faqId/edit': typeof BaseLayoutChatsChatIdFaqsFaqIdEditRoute
  '/chats/$chatId/feeds/$feedId/attributes': typeof BaseLayoutChatsChatIdFeedsFeedIdAttributesRoute
  '/chats/$chatId/feeds/$feedId/products': typeof BaseLayoutChatsChatIdFeedsFeedIdProductsRoute
}
export interface FileRoutesByTo {
  '/': typeof BaseLayoutIndexRoute
  '/models': typeof BaseLayoutModelsRoute
  '/chats/create': typeof BaseLayoutChatsCreateRoute
  '/organizations/create': typeof BaseLayoutOrganizationsCreateRoute
  '/partner-billing/$organizationId': typeof BaseLayoutPartnerBillingOrganizationIdRoute
  '/users/create': typeof BaseLayoutUsersCreateRoute
  '/forgotten-password': typeof AuthLayoutForgottenPasswordIndexRoute
  '/login': typeof AuthLayoutLoginIndexRoute
  '/register': typeof AuthLayoutRegisterIndexRoute
  '/reset-password': typeof AuthLayoutResetPasswordIndexRoute
  '/verify': typeof AuthLayoutVerifyIndexRoute
  '/agent-tools': typeof BaseLayoutAgentToolsIndexRoute
  '/chats': typeof BaseLayoutChatsIndexRoute
  '/knowledge-base': typeof BaseLayoutKnowledgeBaseIndexRoute
  '/organizations': typeof BaseLayoutOrganizationsIndexRoute
  '/users': typeof BaseLayoutUsersIndexRoute
  '/inbox': typeof FullWidthLayoutInboxIndexRoute
  '/agent-tools/client-side/new': typeof BaseLayoutAgentToolsClientSideNewRoute
  '/chats/$chatId/edit': typeof BaseLayoutChatsChatIdEditRoute
  '/organizations/$organizationId/billing': typeof BaseLayoutOrganizationsOrganizationIdBillingRoute
  '/organizations/$organizationId/edit': typeof BaseLayoutOrganizationsOrganizationIdEditRoute
  '/organizations/$organizationId/payments': typeof BaseLayoutOrganizationsOrganizationIdPaymentsRoute
  '/organizations/$organizationId/subscriptions': typeof BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute
  '/users/$userId/edit': typeof BaseLayoutUsersUserIdEditRoute
  '/forgotten-password/sent': typeof AuthLayoutForgottenPasswordSentIndexRoute
  '/register/sent': typeof AuthLayoutRegisterSentIndexRoute
  '/users/profile': typeof BaseLayoutUsersProfileIndexRoute
  '/agent-tools/client-side/$formToolId/edit': typeof BaseLayoutAgentToolsClientSideFormToolIdEditRoute
  '/chats/$chatId/faqs/create': typeof BaseLayoutChatsChatIdFaqsCreateRoute
  '/chats/$chatId/documents': typeof BaseLayoutChatsChatIdDocumentsIndexRoute
  '/chats/$chatId/faqs': typeof BaseLayoutChatsChatIdFaqsIndexRoute
  '/chats/$chatId/feeds': typeof BaseLayoutChatsChatIdFeedsIndexRoute
  '/organizations/$organizationId/plan-management': typeof BaseLayoutOrganizationsOrganizationIdPlanManagementIndexRoute
  '/chats/$chatId/faqs/$faqId/edit': typeof BaseLayoutChatsChatIdFaqsFaqIdEditRoute
  '/chats/$chatId/feeds/$feedId/attributes': typeof BaseLayoutChatsChatIdFeedsFeedIdAttributesRoute
  '/chats/$chatId/feeds/$feedId/products': typeof BaseLayoutChatsChatIdFeedsFeedIdProductsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authLayout': typeof AuthLayoutRouteWithChildren
  '/_baseLayout': typeof BaseLayoutRouteWithChildren
  '/_fullWidthLayout': typeof FullWidthLayoutRouteWithChildren
  '/_baseLayout/models': typeof BaseLayoutModelsRoute
  '/_baseLayout/': typeof BaseLayoutIndexRoute
  '/_baseLayout/chats/create': typeof BaseLayoutChatsCreateRoute
  '/_baseLayout/organizations/create': typeof BaseLayoutOrganizationsCreateRoute
  '/_baseLayout/partner-billing/$organizationId': typeof BaseLayoutPartnerBillingOrganizationIdRoute
  '/_baseLayout/users/create': typeof BaseLayoutUsersCreateRoute
  '/_authLayout/forgotten-password/': typeof AuthLayoutForgottenPasswordIndexRoute
  '/_authLayout/login/': typeof AuthLayoutLoginIndexRoute
  '/_authLayout/register/': typeof AuthLayoutRegisterIndexRoute
  '/_authLayout/reset-password/': typeof AuthLayoutResetPasswordIndexRoute
  '/_authLayout/verify/': typeof AuthLayoutVerifyIndexRoute
  '/_baseLayout/agent-tools/': typeof BaseLayoutAgentToolsIndexRoute
  '/_baseLayout/chats/': typeof BaseLayoutChatsIndexRoute
  '/_baseLayout/knowledge-base/': typeof BaseLayoutKnowledgeBaseIndexRoute
  '/_baseLayout/organizations/': typeof BaseLayoutOrganizationsIndexRoute
  '/_baseLayout/users/': typeof BaseLayoutUsersIndexRoute
  '/_fullWidthLayout/inbox/': typeof FullWidthLayoutInboxIndexRoute
  '/_baseLayout/agent-tools/client-side/new': typeof BaseLayoutAgentToolsClientSideNewRoute
  '/_baseLayout/chats/$chatId/edit': typeof BaseLayoutChatsChatIdEditRoute
  '/_baseLayout/organizations/$organizationId/billing': typeof BaseLayoutOrganizationsOrganizationIdBillingRoute
  '/_baseLayout/organizations/$organizationId/edit': typeof BaseLayoutOrganizationsOrganizationIdEditRoute
  '/_baseLayout/organizations/$organizationId/payments': typeof BaseLayoutOrganizationsOrganizationIdPaymentsRoute
  '/_baseLayout/organizations/$organizationId/subscriptions': typeof BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute
  '/_baseLayout/users/$userId/edit': typeof BaseLayoutUsersUserIdEditRoute
  '/_authLayout/forgotten-password/sent/': typeof AuthLayoutForgottenPasswordSentIndexRoute
  '/_authLayout/register/sent/': typeof AuthLayoutRegisterSentIndexRoute
  '/_baseLayout/users/profile/': typeof BaseLayoutUsersProfileIndexRoute
  '/_baseLayout/agent-tools/client-side/$formToolId/edit': typeof BaseLayoutAgentToolsClientSideFormToolIdEditRoute
  '/_baseLayout/chats/$chatId/faqs/create': typeof BaseLayoutChatsChatIdFaqsCreateRoute
  '/_baseLayout/chats/$chatId/documents/': typeof BaseLayoutChatsChatIdDocumentsIndexRoute
  '/_baseLayout/chats/$chatId/faqs/': typeof BaseLayoutChatsChatIdFaqsIndexRoute
  '/_baseLayout/chats/$chatId/feeds/': typeof BaseLayoutChatsChatIdFeedsIndexRoute
  '/_baseLayout/organizations/$organizationId/plan-management/': typeof BaseLayoutOrganizationsOrganizationIdPlanManagementIndexRoute
  '/_baseLayout/chats/$chatId/faqs/$faqId/edit': typeof BaseLayoutChatsChatIdFaqsFaqIdEditRoute
  '/_baseLayout/chats/$chatId/feeds/$feedId/attributes': typeof BaseLayoutChatsChatIdFeedsFeedIdAttributesRoute
  '/_baseLayout/chats/$chatId/feeds/$feedId/products': typeof BaseLayoutChatsChatIdFeedsFeedIdProductsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/models'
    | '/chats/create'
    | '/organizations/create'
    | '/partner-billing/$organizationId'
    | '/users/create'
    | '/forgotten-password/'
    | '/login/'
    | '/register/'
    | '/reset-password/'
    | '/verify/'
    | '/agent-tools/'
    | '/chats/'
    | '/knowledge-base/'
    | '/organizations/'
    | '/users/'
    | '/inbox/'
    | '/agent-tools/client-side/new'
    | '/chats/$chatId/edit'
    | '/organizations/$organizationId/billing'
    | '/organizations/$organizationId/edit'
    | '/organizations/$organizationId/payments'
    | '/organizations/$organizationId/subscriptions'
    | '/users/$userId/edit'
    | '/forgotten-password/sent/'
    | '/register/sent/'
    | '/users/profile/'
    | '/agent-tools/client-side/$formToolId/edit'
    | '/chats/$chatId/faqs/create'
    | '/chats/$chatId/documents/'
    | '/chats/$chatId/faqs/'
    | '/chats/$chatId/feeds/'
    | '/organizations/$organizationId/plan-management/'
    | '/chats/$chatId/faqs/$faqId/edit'
    | '/chats/$chatId/feeds/$feedId/attributes'
    | '/chats/$chatId/feeds/$feedId/products'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/models'
    | '/chats/create'
    | '/organizations/create'
    | '/partner-billing/$organizationId'
    | '/users/create'
    | '/forgotten-password'
    | '/login'
    | '/register'
    | '/reset-password'
    | '/verify'
    | '/agent-tools'
    | '/chats'
    | '/knowledge-base'
    | '/organizations'
    | '/users'
    | '/inbox'
    | '/agent-tools/client-side/new'
    | '/chats/$chatId/edit'
    | '/organizations/$organizationId/billing'
    | '/organizations/$organizationId/edit'
    | '/organizations/$organizationId/payments'
    | '/organizations/$organizationId/subscriptions'
    | '/users/$userId/edit'
    | '/forgotten-password/sent'
    | '/register/sent'
    | '/users/profile'
    | '/agent-tools/client-side/$formToolId/edit'
    | '/chats/$chatId/faqs/create'
    | '/chats/$chatId/documents'
    | '/chats/$chatId/faqs'
    | '/chats/$chatId/feeds'
    | '/organizations/$organizationId/plan-management'
    | '/chats/$chatId/faqs/$faqId/edit'
    | '/chats/$chatId/feeds/$feedId/attributes'
    | '/chats/$chatId/feeds/$feedId/products'
  id:
    | '__root__'
    | '/_authLayout'
    | '/_baseLayout'
    | '/_fullWidthLayout'
    | '/_baseLayout/models'
    | '/_baseLayout/'
    | '/_baseLayout/chats/create'
    | '/_baseLayout/organizations/create'
    | '/_baseLayout/partner-billing/$organizationId'
    | '/_baseLayout/users/create'
    | '/_authLayout/forgotten-password/'
    | '/_authLayout/login/'
    | '/_authLayout/register/'
    | '/_authLayout/reset-password/'
    | '/_authLayout/verify/'
    | '/_baseLayout/agent-tools/'
    | '/_baseLayout/chats/'
    | '/_baseLayout/knowledge-base/'
    | '/_baseLayout/organizations/'
    | '/_baseLayout/users/'
    | '/_fullWidthLayout/inbox/'
    | '/_baseLayout/agent-tools/client-side/new'
    | '/_baseLayout/chats/$chatId/edit'
    | '/_baseLayout/organizations/$organizationId/billing'
    | '/_baseLayout/organizations/$organizationId/edit'
    | '/_baseLayout/organizations/$organizationId/payments'
    | '/_baseLayout/organizations/$organizationId/subscriptions'
    | '/_baseLayout/users/$userId/edit'
    | '/_authLayout/forgotten-password/sent/'
    | '/_authLayout/register/sent/'
    | '/_baseLayout/users/profile/'
    | '/_baseLayout/agent-tools/client-side/$formToolId/edit'
    | '/_baseLayout/chats/$chatId/faqs/create'
    | '/_baseLayout/chats/$chatId/documents/'
    | '/_baseLayout/chats/$chatId/faqs/'
    | '/_baseLayout/chats/$chatId/feeds/'
    | '/_baseLayout/organizations/$organizationId/plan-management/'
    | '/_baseLayout/chats/$chatId/faqs/$faqId/edit'
    | '/_baseLayout/chats/$chatId/feeds/$feedId/attributes'
    | '/_baseLayout/chats/$chatId/feeds/$feedId/products'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthLayoutRoute: typeof AuthLayoutRouteWithChildren
  BaseLayoutRoute: typeof BaseLayoutRouteWithChildren
  FullWidthLayoutRoute: typeof FullWidthLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authLayout': {
      id: '/_authLayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_baseLayout': {
      id: '/_baseLayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof BaseLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_fullWidthLayout': {
      id: '/_fullWidthLayout'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof FullWidthLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_baseLayout/': {
      id: '/_baseLayout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof BaseLayoutIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/models': {
      id: '/_baseLayout/models'
      path: '/models'
      fullPath: '/models'
      preLoaderRoute: typeof BaseLayoutModelsRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_authLayout/forgotten-password/': {
      id: '/_authLayout/forgotten-password/'
      path: '/forgotten-password'
      fullPath: '/forgotten-password/'
      preLoaderRoute: typeof AuthLayoutForgottenPasswordIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_authLayout/login/': {
      id: '/_authLayout/login/'
      path: '/login'
      fullPath: '/login/'
      preLoaderRoute: typeof AuthLayoutLoginIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_authLayout/register/': {
      id: '/_authLayout/register/'
      path: '/register'
      fullPath: '/register/'
      preLoaderRoute: typeof AuthLayoutRegisterIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_authLayout/reset-password/': {
      id: '/_authLayout/reset-password/'
      path: '/reset-password'
      fullPath: '/reset-password/'
      preLoaderRoute: typeof AuthLayoutResetPasswordIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_authLayout/verify/': {
      id: '/_authLayout/verify/'
      path: '/verify'
      fullPath: '/verify/'
      preLoaderRoute: typeof AuthLayoutVerifyIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_baseLayout/agent-tools/': {
      id: '/_baseLayout/agent-tools/'
      path: '/agent-tools'
      fullPath: '/agent-tools/'
      preLoaderRoute: typeof BaseLayoutAgentToolsIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/': {
      id: '/_baseLayout/chats/'
      path: '/chats'
      fullPath: '/chats/'
      preLoaderRoute: typeof BaseLayoutChatsIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/create': {
      id: '/_baseLayout/chats/create'
      path: '/chats/create'
      fullPath: '/chats/create'
      preLoaderRoute: typeof BaseLayoutChatsCreateRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/knowledge-base/': {
      id: '/_baseLayout/knowledge-base/'
      path: '/knowledge-base'
      fullPath: '/knowledge-base/'
      preLoaderRoute: typeof BaseLayoutKnowledgeBaseIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/organizations/': {
      id: '/_baseLayout/organizations/'
      path: '/organizations'
      fullPath: '/organizations/'
      preLoaderRoute: typeof BaseLayoutOrganizationsIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/organizations/create': {
      id: '/_baseLayout/organizations/create'
      path: '/organizations/create'
      fullPath: '/organizations/create'
      preLoaderRoute: typeof BaseLayoutOrganizationsCreateRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/partner-billing/$organizationId': {
      id: '/_baseLayout/partner-billing/$organizationId'
      path: '/partner-billing/$organizationId'
      fullPath: '/partner-billing/$organizationId'
      preLoaderRoute: typeof BaseLayoutPartnerBillingOrganizationIdRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/users/': {
      id: '/_baseLayout/users/'
      path: '/users'
      fullPath: '/users/'
      preLoaderRoute: typeof BaseLayoutUsersIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/users/create': {
      id: '/_baseLayout/users/create'
      path: '/users/create'
      fullPath: '/users/create'
      preLoaderRoute: typeof BaseLayoutUsersCreateRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_fullWidthLayout/inbox/': {
      id: '/_fullWidthLayout/inbox/'
      path: '/inbox'
      fullPath: '/inbox/'
      preLoaderRoute: typeof FullWidthLayoutInboxIndexRouteImport
      parentRoute: typeof FullWidthLayoutRoute
    }
    '/_authLayout/forgotten-password/sent/': {
      id: '/_authLayout/forgotten-password/sent/'
      path: '/forgotten-password/sent'
      fullPath: '/forgotten-password/sent/'
      preLoaderRoute: typeof AuthLayoutForgottenPasswordSentIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_authLayout/register/sent/': {
      id: '/_authLayout/register/sent/'
      path: '/register/sent'
      fullPath: '/register/sent/'
      preLoaderRoute: typeof AuthLayoutRegisterSentIndexRouteImport
      parentRoute: typeof AuthLayoutRoute
    }
    '/_baseLayout/agent-tools/client-side/new': {
      id: '/_baseLayout/agent-tools/client-side/new'
      path: '/agent-tools/client-side/new'
      fullPath: '/agent-tools/client-side/new'
      preLoaderRoute: typeof BaseLayoutAgentToolsClientSideNewRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/$chatId/edit': {
      id: '/_baseLayout/chats/$chatId/edit'
      path: '/chats/$chatId/edit'
      fullPath: '/chats/$chatId/edit'
      preLoaderRoute: typeof BaseLayoutChatsChatIdEditRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/organizations/$organizationId/billing': {
      id: '/_baseLayout/organizations/$organizationId/billing'
      path: '/organizations/$organizationId/billing'
      fullPath: '/organizations/$organizationId/billing'
      preLoaderRoute: typeof BaseLayoutOrganizationsOrganizationIdBillingRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/organizations/$organizationId/edit': {
      id: '/_baseLayout/organizations/$organizationId/edit'
      path: '/organizations/$organizationId/edit'
      fullPath: '/organizations/$organizationId/edit'
      preLoaderRoute: typeof BaseLayoutOrganizationsOrganizationIdEditRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/organizations/$organizationId/payments': {
      id: '/_baseLayout/organizations/$organizationId/payments'
      path: '/organizations/$organizationId/payments'
      fullPath: '/organizations/$organizationId/payments'
      preLoaderRoute: typeof BaseLayoutOrganizationsOrganizationIdPaymentsRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/organizations/$organizationId/subscriptions': {
      id: '/_baseLayout/organizations/$organizationId/subscriptions'
      path: '/organizations/$organizationId/subscriptions'
      fullPath: '/organizations/$organizationId/subscriptions'
      preLoaderRoute: typeof BaseLayoutOrganizationsOrganizationIdSubscriptionsRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/users/$userId/edit': {
      id: '/_baseLayout/users/$userId/edit'
      path: '/users/$userId/edit'
      fullPath: '/users/$userId/edit'
      preLoaderRoute: typeof BaseLayoutUsersUserIdEditRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/users/profile/': {
      id: '/_baseLayout/users/profile/'
      path: '/users/profile'
      fullPath: '/users/profile/'
      preLoaderRoute: typeof BaseLayoutUsersProfileIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/agent-tools/client-side/$formToolId/edit': {
      id: '/_baseLayout/agent-tools/client-side/$formToolId/edit'
      path: '/agent-tools/client-side/$formToolId/edit'
      fullPath: '/agent-tools/client-side/$formToolId/edit'
      preLoaderRoute: typeof BaseLayoutAgentToolsClientSideFormToolIdEditRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/$chatId/documents/': {
      id: '/_baseLayout/chats/$chatId/documents/'
      path: '/chats/$chatId/documents'
      fullPath: '/chats/$chatId/documents/'
      preLoaderRoute: typeof BaseLayoutChatsChatIdDocumentsIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/$chatId/faqs/': {
      id: '/_baseLayout/chats/$chatId/faqs/'
      path: '/chats/$chatId/faqs'
      fullPath: '/chats/$chatId/faqs/'
      preLoaderRoute: typeof BaseLayoutChatsChatIdFaqsIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/$chatId/faqs/create': {
      id: '/_baseLayout/chats/$chatId/faqs/create'
      path: '/chats/$chatId/faqs/create'
      fullPath: '/chats/$chatId/faqs/create'
      preLoaderRoute: typeof BaseLayoutChatsChatIdFaqsCreateRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/$chatId/feeds/': {
      id: '/_baseLayout/chats/$chatId/feeds/'
      path: '/chats/$chatId/feeds'
      fullPath: '/chats/$chatId/feeds/'
      preLoaderRoute: typeof BaseLayoutChatsChatIdFeedsIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/organizations/$organizationId/plan-management/': {
      id: '/_baseLayout/organizations/$organizationId/plan-management/'
      path: '/organizations/$organizationId/plan-management'
      fullPath: '/organizations/$organizationId/plan-management/'
      preLoaderRoute: typeof BaseLayoutOrganizationsOrganizationIdPlanManagementIndexRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/$chatId/faqs/$faqId/edit': {
      id: '/_baseLayout/chats/$chatId/faqs/$faqId/edit'
      path: '/chats/$chatId/faqs/$faqId/edit'
      fullPath: '/chats/$chatId/faqs/$faqId/edit'
      preLoaderRoute: typeof BaseLayoutChatsChatIdFaqsFaqIdEditRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/$chatId/feeds/$feedId/attributes': {
      id: '/_baseLayout/chats/$chatId/feeds/$feedId/attributes'
      path: '/chats/$chatId/feeds/$feedId/attributes'
      fullPath: '/chats/$chatId/feeds/$feedId/attributes'
      preLoaderRoute: typeof BaseLayoutChatsChatIdFeedsFeedIdAttributesRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
    '/_baseLayout/chats/$chatId/feeds/$feedId/products': {
      id: '/_baseLayout/chats/$chatId/feeds/$feedId/products'
      path: '/chats/$chatId/feeds/$feedId/products'
      fullPath: '/chats/$chatId/feeds/$feedId/products'
      preLoaderRoute: typeof BaseLayoutChatsChatIdFeedsFeedIdProductsRouteImport
      parentRoute: typeof BaseLayoutRoute
    }
  }
}

interface AuthLayoutRouteChildren {
  AuthLayoutForgottenPasswordIndexRoute: typeof AuthLayoutForgottenPasswordIndexRoute
  AuthLayoutLoginIndexRoute: typeof AuthLayoutLoginIndexRoute
  AuthLayoutRegisterIndexRoute: typeof AuthLayoutRegisterIndexRoute
  AuthLayoutResetPasswordIndexRoute: typeof AuthLayoutResetPasswordIndexRoute
  AuthLayoutVerifyIndexRoute: typeof AuthLayoutVerifyIndexRoute
  AuthLayoutForgottenPasswordSentIndexRoute: typeof AuthLayoutForgottenPasswordSentIndexRoute
  AuthLayoutRegisterSentIndexRoute: typeof AuthLayoutRegisterSentIndexRoute
}

const AuthLayoutRouteChildren: AuthLayoutRouteChildren = {
  AuthLayoutForgottenPasswordIndexRoute: AuthLayoutForgottenPasswordIndexRoute,
  AuthLayoutLoginIndexRoute: AuthLayoutLoginIndexRoute,
  AuthLayoutRegisterIndexRoute: AuthLayoutRegisterIndexRoute,
  AuthLayoutResetPasswordIndexRoute: AuthLayoutResetPasswordIndexRoute,
  AuthLayoutVerifyIndexRoute: AuthLayoutVerifyIndexRoute,
  AuthLayoutForgottenPasswordSentIndexRoute:
    AuthLayoutForgottenPasswordSentIndexRoute,
  AuthLayoutRegisterSentIndexRoute: AuthLayoutRegisterSentIndexRoute,
}

const AuthLayoutRouteWithChildren = AuthLayoutRoute._addFileChildren(
  AuthLayoutRouteChildren,
)

interface BaseLayoutRouteChildren {
  BaseLayoutModelsRoute: typeof BaseLayoutModelsRoute
  BaseLayoutIndexRoute: typeof BaseLayoutIndexRoute
  BaseLayoutChatsCreateRoute: typeof BaseLayoutChatsCreateRoute
  BaseLayoutOrganizationsCreateRoute: typeof BaseLayoutOrganizationsCreateRoute
  BaseLayoutPartnerBillingOrganizationIdRoute: typeof BaseLayoutPartnerBillingOrganizationIdRoute
  BaseLayoutUsersCreateRoute: typeof BaseLayoutUsersCreateRoute
  BaseLayoutAgentToolsIndexRoute: typeof BaseLayoutAgentToolsIndexRoute
  BaseLayoutChatsIndexRoute: typeof BaseLayoutChatsIndexRoute
  BaseLayoutKnowledgeBaseIndexRoute: typeof BaseLayoutKnowledgeBaseIndexRoute
  BaseLayoutOrganizationsIndexRoute: typeof BaseLayoutOrganizationsIndexRoute
  BaseLayoutUsersIndexRoute: typeof BaseLayoutUsersIndexRoute
  BaseLayoutAgentToolsClientSideNewRoute: typeof BaseLayoutAgentToolsClientSideNewRoute
  BaseLayoutChatsChatIdEditRoute: typeof BaseLayoutChatsChatIdEditRoute
  BaseLayoutOrganizationsOrganizationIdBillingRoute: typeof BaseLayoutOrganizationsOrganizationIdBillingRoute
  BaseLayoutOrganizationsOrganizationIdEditRoute: typeof BaseLayoutOrganizationsOrganizationIdEditRoute
  BaseLayoutOrganizationsOrganizationIdPaymentsRoute: typeof BaseLayoutOrganizationsOrganizationIdPaymentsRoute
  BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute: typeof BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute
  BaseLayoutUsersUserIdEditRoute: typeof BaseLayoutUsersUserIdEditRoute
  BaseLayoutUsersProfileIndexRoute: typeof BaseLayoutUsersProfileIndexRoute
  BaseLayoutAgentToolsClientSideFormToolIdEditRoute: typeof BaseLayoutAgentToolsClientSideFormToolIdEditRoute
  BaseLayoutChatsChatIdFaqsCreateRoute: typeof BaseLayoutChatsChatIdFaqsCreateRoute
  BaseLayoutChatsChatIdDocumentsIndexRoute: typeof BaseLayoutChatsChatIdDocumentsIndexRoute
  BaseLayoutChatsChatIdFaqsIndexRoute: typeof BaseLayoutChatsChatIdFaqsIndexRoute
  BaseLayoutChatsChatIdFeedsIndexRoute: typeof BaseLayoutChatsChatIdFeedsIndexRoute
  BaseLayoutOrganizationsOrganizationIdPlanManagementIndexRoute: typeof BaseLayoutOrganizationsOrganizationIdPlanManagementIndexRoute
  BaseLayoutChatsChatIdFaqsFaqIdEditRoute: typeof BaseLayoutChatsChatIdFaqsFaqIdEditRoute
  BaseLayoutChatsChatIdFeedsFeedIdAttributesRoute: typeof BaseLayoutChatsChatIdFeedsFeedIdAttributesRoute
  BaseLayoutChatsChatIdFeedsFeedIdProductsRoute: typeof BaseLayoutChatsChatIdFeedsFeedIdProductsRoute
}

const BaseLayoutRouteChildren: BaseLayoutRouteChildren = {
  BaseLayoutModelsRoute: BaseLayoutModelsRoute,
  BaseLayoutIndexRoute: BaseLayoutIndexRoute,
  BaseLayoutChatsCreateRoute: BaseLayoutChatsCreateRoute,
  BaseLayoutOrganizationsCreateRoute: BaseLayoutOrganizationsCreateRoute,
  BaseLayoutPartnerBillingOrganizationIdRoute:
    BaseLayoutPartnerBillingOrganizationIdRoute,
  BaseLayoutUsersCreateRoute: BaseLayoutUsersCreateRoute,
  BaseLayoutAgentToolsIndexRoute: BaseLayoutAgentToolsIndexRoute,
  BaseLayoutChatsIndexRoute: BaseLayoutChatsIndexRoute,
  BaseLayoutKnowledgeBaseIndexRoute: BaseLayoutKnowledgeBaseIndexRoute,
  BaseLayoutOrganizationsIndexRoute: BaseLayoutOrganizationsIndexRoute,
  BaseLayoutUsersIndexRoute: BaseLayoutUsersIndexRoute,
  BaseLayoutAgentToolsClientSideNewRoute:
    BaseLayoutAgentToolsClientSideNewRoute,
  BaseLayoutChatsChatIdEditRoute: BaseLayoutChatsChatIdEditRoute,
  BaseLayoutOrganizationsOrganizationIdBillingRoute:
    BaseLayoutOrganizationsOrganizationIdBillingRoute,
  BaseLayoutOrganizationsOrganizationIdEditRoute:
    BaseLayoutOrganizationsOrganizationIdEditRoute,
  BaseLayoutOrganizationsOrganizationIdPaymentsRoute:
    BaseLayoutOrganizationsOrganizationIdPaymentsRoute,
  BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute:
    BaseLayoutOrganizationsOrganizationIdSubscriptionsRoute,
  BaseLayoutUsersUserIdEditRoute: BaseLayoutUsersUserIdEditRoute,
  BaseLayoutUsersProfileIndexRoute: BaseLayoutUsersProfileIndexRoute,
  BaseLayoutAgentToolsClientSideFormToolIdEditRoute:
    BaseLayoutAgentToolsClientSideFormToolIdEditRoute,
  BaseLayoutChatsChatIdFaqsCreateRoute: BaseLayoutChatsChatIdFaqsCreateRoute,
  BaseLayoutChatsChatIdDocumentsIndexRoute:
    BaseLayoutChatsChatIdDocumentsIndexRoute,
  BaseLayoutChatsChatIdFaqsIndexRoute: BaseLayoutChatsChatIdFaqsIndexRoute,
  BaseLayoutChatsChatIdFeedsIndexRoute: BaseLayoutChatsChatIdFeedsIndexRoute,
  BaseLayoutOrganizationsOrganizationIdPlanManagementIndexRoute:
    BaseLayoutOrganizationsOrganizationIdPlanManagementIndexRoute,
  BaseLayoutChatsChatIdFaqsFaqIdEditRoute:
    BaseLayoutChatsChatIdFaqsFaqIdEditRoute,
  BaseLayoutChatsChatIdFeedsFeedIdAttributesRoute:
    BaseLayoutChatsChatIdFeedsFeedIdAttributesRoute,
  BaseLayoutChatsChatIdFeedsFeedIdProductsRoute:
    BaseLayoutChatsChatIdFeedsFeedIdProductsRoute,
}

const BaseLayoutRouteWithChildren = BaseLayoutRoute._addFileChildren(
  BaseLayoutRouteChildren,
)

interface FullWidthLayoutRouteChildren {
  FullWidthLayoutInboxIndexRoute: typeof FullWidthLayoutInboxIndexRoute
}

const FullWidthLayoutRouteChildren: FullWidthLayoutRouteChildren = {
  FullWidthLayoutInboxIndexRoute: FullWidthLayoutInboxIndexRoute,
}

const FullWidthLayoutRouteWithChildren = FullWidthLayoutRoute._addFileChildren(
  FullWidthLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthLayoutRoute: AuthLayoutRouteWithChildren,
  BaseLayoutRoute: BaseLayoutRouteWithChildren,
  FullWidthLayoutRoute: FullWidthLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
